import { createClient } from '@supabase/supabase-js';

import { env } from '../config/env';

export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    // auth-js defaults to the implicit grant, which returns the session in the URL
    // fragment and then clears it with `window.location.hash = ''` — that assignment
    // leaves a bare `#` in the address bar after every OAuth sign-in. PKCE returns a
    // `?code=` query param instead and strips it with `history.replaceState`.
    flowType: 'pkce',
  },
});
